<template>
  <div class="my-profile tongxin-layout">
    <h1 class="title-with-underline">本人資料</h1>

    <div class="profile-card">
      <!-- <div class="profile-header">
        <h2 class="profile-name">{{ profileData.name || '本人' }}</h2>
        <span class="profile-badge">本人</span>
      </div> -->

      <div class="profile-body">
        <div class="info-row">
          <span class="label">姓名</span>
          <span class="value">{{ profileData.name }}</span>
        </div>

        <div class="info-row">
          <span class="label">身分證字號</span>
          <span class="value">{{ maskedIdno }}</span>
        </div>

        <div class="info-row">
          <span class="label">出生年月日</span>
          <span class="value">{{ profileData.birthday }}</span>
        </div>
      </div>

      <div class="profile-footer">
        <div class="reminder-green">
          {{ reminderText }}
        </div>
      </div>
    </div>

    <div style="padding-bottom: 96px"></div>
    <div class="fixed-footer-navigation">
      <button class="btn btn-secondary w-50" @click="goBack">
        返回
      </button>
    </div>
  </div>
</template>

<script>
import tongxinApi from '@/apis/web/tongxin'

export default {
  name: 'TongxinFamilyMyProfile',
  inject: ['clinicIdData'],
  data() {
    return {
      profileData: {
        name: '',
        idno: '',
        birthday: '',
      },
      reminderText: '電話號碼若有異動，請先至「重新綁定手機號碼」處理後，再回到本頁修改您的基本資料。',
    }
  },
  computed: {
    selfProfile() {
      return this.$store.state.liffAuth.user
    },
    maskedIdno() {
      const idno = this.profileData.idno
      if (!idno || idno.length < 10) {
        return ''
      }
      // 顯示前 4 碼和後 3 碼，中間遮蔽
      return `${idno.slice(0, 4)}***${idno.slice(-3)}`
    },
  },
  created() {
    this.loadProfile()
  },
  methods: {
    async loadProfile() {
      try {
        const { data: res = {} } = await tongxinApi.getCustomerInfo()
        this.profileData = {
          name: res.name,
          idno: res.customer_code,
          birthday: res.birthday,
        }
      } catch (error) {
        console.error('取得本人資料失敗:', error)
      }
    },

    goBack() {
      this.$router.push({ name: 'TongxinFamilyList' })
    },
  },
}
</script>

<style lang="scss" scoped>
.my-profile {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;

  .profile-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    padding: 24px;
    margin-top: 40px;

    .profile-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 24px;
      padding-bottom: 16px;
      border-bottom: 2px solid #f0f0f0;

      .profile-name {
        font-size: 24px;
        font-weight: bold;
        color: #333;
        margin: 0;
      }

      .profile-badge {
        background: #207868;
        color: white;
        padding: 6px 16px;
        border-radius: 16px;
        font-size: 14px;
        font-weight: 600;
      }
    }

    .profile-body {
      margin-bottom: 24px;

      .info-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 0;
        border-bottom: 1px solid #f0f0f0;

        &:last-child {
          border-bottom: none;
        }

        .label {
          font-size: 16px;
          color: #666;
          font-weight: 500;
        }

        .value {
          font-size: 16px;
          color: #333;
          font-weight: 600;
        }
      }
    }

    .profile-footer {
      .reminder-green {
        background: #e8f5f3;
        border-left: 4px solid #207868;
        padding: 16px;
        border-radius: 4px;
        font-size: 14px;
        color: #333;
        line-height: 1.6;
      }
    }
  }
}
</style>
